// Shop-selectable display currencies. Each shop picks one (shopData.currency,
// default 'USD') and every price shown for that shop's items/services — on
// the welcome page, the public shop page, and the owner's own edit view —
// is formatted using it instead of always assuming USD.
export const CURRENCIES = [
  { code: 'USD', label: 'US Dollar ($)',        symbol: '$',   position: 'prefix', decimals: 2 },
  { code: 'ETB', label: 'Ethiopian Birr (br)',  symbol: 'br',  position: 'suffix', decimals: 0 },
  { code: 'EUR', label: 'Euro (€)',        symbol: '€', position: 'prefix', decimals: 2 },
  { code: 'GBP', label: 'British Pound (£)', symbol: '£', position: 'prefix', decimals: 2 },
  { code: 'CAD', label: 'Canadian Dollar (CA$)', symbol: 'CA$', position: 'prefix', decimals: 2 },
  { code: 'KES', label: 'Kenyan Shilling (KSh)', symbol: 'KSh', position: 'prefix', decimals: 0 },
  { code: 'NGN', label: 'Nigerian Naira (₦)', symbol: '₦', position: 'prefix', decimals: 2 },
];

export const getCurrency = (code) => CURRENCIES.find(c => c.code === code) || CURRENCIES[0];

export const formatShopPrice = (price, currencyCode = 'USD') => {
  const currency = getCurrency(currencyCode);
  const num = parseFloat(price);
  const safeNum = isNaN(num) ? 0 : num;
  const formatted = currency.decimals > 0 ? safeNum.toFixed(currency.decimals) : Math.round(safeNum).toString();
  return currency.position === 'prefix' ? `${currency.symbol}${formatted}` : `${formatted}${currency.symbol}`;
};
